import {
  PLATE_PRODUCTION_EXPORT_HEADERS,
  buildPlateProductionExportRows,
} from "./plateProductionExportHelpers";

export const convertPlateProductionToCSV = (responseData) => {
  const dataRows = buildPlateProductionExportRows(responseData);

  const rows = [
    [
      "Plate Production",
      "",
      "",
      "Plate(s)",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    PLATE_PRODUCTION_EXPORT_HEADERS,
    ...dataRows,
  ];

  return rows
    .map((row) =>
      row
        .map((cell) => {
          const cellStr = String(cell);
          if (
            cellStr.includes(",") ||
            cellStr.includes('"') ||
            cellStr.includes("\n")
          ) {
            return `"${cellStr.replace(/"/g, '""')}"`;
          }
          return cellStr;
        })
        .join(","),
    )
    .join("\n");
};

export const downloadPlateProductionCSV = (
  productionData,
  filename = "plate_production_report.csv",
) => {
  const csvContent = convertPlateProductionToCSV(productionData);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
